import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusCard } from './PurchaseV2.styles';

// v2 look shared by the status screens (6, 8 and 9): a round icon, a title and
// the message. `tone` is "success" (green) or "danger" (red).
function StatusAlertCard({
  tone = 'success', icon, title, children,
}) {
  return (
    <StatusCard $tone={tone} role="alert">
      <span className="status-icon">
        <FontAwesomeIcon icon={icon} />
      </span>
      <div>
        <h4>{title}</h4>
        {children}
      </div>
    </StatusCard>
  );
}

export default StatusAlertCard;
